/**
 *   Generated file. Do not edit
 */

import { ReadSelectedFileParams } from './models';
import { TapStreamReader } from '@iotize/tap/client/impl';
import { TapStreamWriter } from '@iotize/tap/client/impl';
import { FixedSizeEnumConverter } from '@iotize/tap/client/impl';
import { enumKeyOrValueToNumber } from '@iotize/tap/client/impl';

declare module '@iotize/tap/client/impl/lib/frame/tap-stream-core' {
  export interface TapStreamReader {
    readReadSelectedFileParams(): ReadSelectedFileParams;
  }
  export interface TapStreamWriter {
    writeReadSelectedFileParams(model: ReadSelectedFileParams): TapStreamWriter;
  }
}

TapStreamReader.prototype.readReadSelectedFileParams =
  function (): ReadSelectedFileParams {
    const model: Partial<ReadSelectedFileParams> = {};

    model.offset = this.readUnsigned(4);

    model.size = this.readUnsigned(4);

    return model as ReadSelectedFileParams;
  };

// TapStreamWriter.prototype.write(model: ReadSelectedFileParams) : TapStreamWriter{
//     return this.writeReadSelectedFileParams(model)
// }

TapStreamWriter.prototype.writeReadSelectedFileParams = function (
  model: ReadSelectedFileParams,
): TapStreamWriter {
  this.writeUnsigned(model.offset, 4);

  this.writeUnsigned(model.size, 4);

  return this;
};
